import { SELECTOR_MAGIC_OFFSET } from './constants.js';
import { decode } from './decode.js';

/**
 * Get the index of the selector with the given depth
 * @param selector
 * @param depth
 * @returns
 */
export const getIndex = (selector: string, depth = -1) => {
  const buffer = decode(selector);
  const bytes = 2;
  const length = buffer.length / bytes;
  const offset = ((length + depth) % length) * bytes;
  const view = new DataView(buffer.buffer);
  return view.getUint16(offset, true) - SELECTOR_MAGIC_OFFSET;
};
